import * as React from 'react'

import { useData } from './useData'
import { splitCamelCase } from '@sales-center/common'

import {
  Alert,
  Panel,
  TableCell,
  TableHeadCell,
  CircularProgress,
} from '../atoms'

import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import TableHead from '@mui/material/TableHead'
import { ENTITY_TYPES } from '@sales-center/common'

export type AgreementsProps = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function Agreements(props: AgreementsProps) {
  const { title, status, agreements } = useData(props)

  return (
    <Panel icon="agreement" title={title}>
      {status === 'pending' && <CircularProgress />}

      {status === 'fail' && (
        <Alert severity="error">Failed to load Agreements.</Alert>
      )}

      {status === 'success' &&
        (agreements.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadCell>Name</TableHeadCell>
                <TableHeadCell>Status</TableHeadCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {agreements.map((c) => (
                <TableRow key={c.id}>
                  <TableCell>{c.formName}</TableCell>
                  <TableCell>{splitCamelCase(c.status)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Alert severity="info">
            This Opportunity has no associated Agreements.
          </Alert>
        ))}
    </Panel>
  )
}
